let magic = {
    //判断是否有权限
    ifRightsFn(productId) {

        return new Promise(function(resolve, reject) {

            // let productId = '';
            // if (that.$route.query.dbcode) {
            //     productId = that.$route.query.dbcode == 2 ? 0 : (that.$route.query.dbcode == 1 ? 1 : '');
            // }

            // if (productId == 0 || productId == 1) {

            api.weighterRights(productId).then(res => {
                // console.log(res.data, 'res')
                resolve(res.data);
            });
            // } else {
            //     resolve(false);
            // }
        })
    },
    figgerPrint() {
        let _this = this;
        return new Promise(function(resolve, reject) {
            // let myOptions = {
            //   excludes: {
            //     language: true,
            //     colorDepth: true,
            //     deviceMemory: true,
            //     pixelRatio: true,
            //     availableScreenResolution: true,
            //     timezoneOffset: true,
            //     timezone: true,
            //     sessionStorage: true,
            //     localStorage: true,
            //     indexedDb: true,
            //     addBehavior: true,
            //     openDatabase: true,
            //     cpuClass: true,
            //     doNotTrack: true,
            //     plugins: true,
            //     canvas: true,
            //     webglVendorAndRenderer: true,
            //     adBlock: true,
            //     hasLiedLanguages: true,
            //     hasLiedResolution: true,
            //     hasLiedOs: true,
            //     hasLiedBrowser: true,
            //     touchSupport: true,
            //     audio: false,
            //     enumerateDevices: true,
            //     hardwareConcurrency: true,
            //   },
            // };
            let myOptions = getDRCNetFingerConfig();
            // console.log(myOptions, 'myOptions')
            let tmpCodes = ''
            if (window.requestIdleCallback) {
                Fingerprint2.get(myOptions, function(components) {
                    // console.log(components,'components');
                    var option = components.filter(function(pair) {
                        if (pair.key == "userAgent" || pair.key == "availableScreenResolution") {
                            return false;
                        }
                        return true;
                    }).map(function(pair) {
                        return pair.value;
                    });
                    var murmur = Fingerprint2.x64hash128(option.join(), 31);
                    // document.querySelector("#fp").textContent = murmur;
                    // window.guid = murmur;
                    resolve(murmur);
                })
            } else {
                setTimeout(() => {
                    Fingerprint2.get(myOptions, function(components) {
                        // console.log(components,'components');
                        var option = components.filter(function(pair) {
                            if (pair.key == "userAgent" || pair.key == "availableScreenResolution") {
                                return false;
                            }
                            return true;
                        }).map(function(pair) {
                            return pair.value;
                        });
                        var murmur = Fingerprint2.x64hash128(option.join(), 31);
                        // document.querySelector("#fp").textContent = murmur;
                        // window.guid = murmur;
                        resolve(murmur);
                    })
                }, 500);
            }
        })
    },
    loginOrRights(productId) {
        let _this = this;

        return new Promise(function(resolve, reject) {

            setTimeout(() => {
                _this.figgerPrint().then(guid => {
                    api.iflogin(guid).then(res => {
                        if (res.UserToken) {
                            _this.ifRightsFn(productId).then(ress => {

                                let tmpObj = {
                                    loginId: res.Logined,
                                    token: res.UserToken,
                                    userName: res.UserName,
                                    rights: ress ? 1 : 0,
                                    userId: res.userId
                                }

                                localStorage.setItem('usersInfo', JSON.stringify(tmpObj));

                                sessionStorage.setItem("Authorization", res.UserToken);

                                _this.users = tmpObj;

                                resolve(tmpObj);
                            });
                        } else {
                            localStorage.removeItem("usersInfo");
                            sessionStorage.removeItem("Authorization");

                            resolve(false);
                        }
                    });
                });

            }, 500);
        })
    },
    //时间戳转日期时间
    TimestampToDateTime: function(timestamp) {
        var date = new Date(timestamp);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        second = second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
    },
    //获取当前向前推几年的时间
    getSomeYearsBefor(years) {
        let resultDate, year, month, date, hms;
        let currDate = new Date();
        year = currDate.getFullYear();
        month = currDate.getMonth() + 1;
        date = currDate.getDate();
        hms = currDate.getHours() + ':' + currDate.getMinutes() + ':' + (currDate.getSeconds() < 10 ? '0' + currDate.getSeconds() : currDate.getSeconds());
        switch (year) {
            case 1:
            case 2:
            default:
                year -= years;
                break;
        }
        month = (month < 10) ? ('0' + month) : month;
        resultDate = year + '-' + month + '-' + date + ' ' + hms;
        return resultDate;
    },
    //获取url中的参数
    GetUrlParam: function(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); // 构造一个含有目标参数的正则表达式对象
        var r = window.location.search.substr(1).match(reg); // 匹配目标参数
        if (r != null) return unescape(r[2]);
        return null; // 返回参数值
    },
    //获取url中的参数
    getUrlKey(name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
    },
    /**
     * @param {想要获取的当前参数名} name 
     */
    getQueryString(name) {
        //获取url的指定参数名的值
        //没有则返回null
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
    },
    //创建script标签
    createScrit: function(src) {
        let head = document.getElementsByTagName('head')[0];
        let script = document.createElement('script');
        var _id = this.sum();
        script.setAttribute('id', _id);
        script.type = 'text/javascript';
        script.src = src;
        head.appendChild(script);
        return _id;
    },
    //生成一个多位的随机数
    sum: function() {
        return Math.floor(Math.random() * (1 - 5000) + 5000) + '' + Math.floor(Math.random() * (1 - 4000) + 4000) + '' + Math.floor(Math.random() * (1 - 3000) + 3000);
    },
    /**
     * 分页组件
     * @param {*} boxId 分页动态加在的外界容器ID '#boxID'
     * @param {*} total 用页数
     * @param {*} pageSize 每页显示条数
     * @param {*} curPage 当前页
     * @param {*} fun 回调函数
     */
    page: function(boxId, total, pageSize, curPage, fun) {
        //分页函数--右侧
        var _this = this;
        var num = 0;
        var PageObj = { //定义分页参数和方法
            obj_box: boxId, //翻页容器
            total_item: total, //条目总数
            per_num: pageSize, //每页条目数
            current_page: curPage, //当前页
            //此处,请为页面翻页展示内容定义方法
            change_content: function change_content(per_num, current_page) {
                per_num = per_num ? per_num : 10; //每页显示条数,默认为10条
                current_page = current_page ? current_page : 1; //当前页,默认为1

                // let nowUrl = window.location.href;
                // let currentUrl = magic.changeURLPar(nowUrl,'pageRNumber',current_page);                    
                // if(num){
                // 	window.history.pushState(null,null,currentUrl);         //无刷新更新页面url
                // 	_this.init(_this.data.startTime,_this.data.endTime);
                // }
                // num++;
                fun(per_num, current_page);
            }
        };
        this.page_ctrl(PageObj); //调用分页插件
    },
    page_ctrl: function(data_obj) {
        var obj_box = (data_obj.obj_box !== undefined) ? data_obj.obj_box : function() {
            return;
        }; //翻页容器dom对象,必要参数
        var total_item = (data_obj.total_item !== undefined) ? parseInt(data_obj.total_item) : 0; //数据条目总数,默认为0,组件将不加载
        var per_num = (data_obj.per_num !== undefined) ? parseInt(data_obj.per_num) : 10; //每页显示条数,默认为10条
        var current_page = (data_obj.current_page !== undefined) ? parseInt(data_obj.current_page) : 1; //当前页,默认为1
        var total_page = Math.ceil(total_item / per_num); //计算总页数,不足2页,不加载组件
        if (total_page < 2) {
            return;
        }
        //在指定容器内加载分页数据
        $(obj_box).append('<div class="page_content"></div>');
        //在指定容器内加载分页插件
        $(obj_box).append('<div class="page_ctrl"></div>');

        function page_even() {
            //当前页限定,非数字或小于1跳转到第一页,大于总页数,跳转到最后一页
            var regPos = /^\d+$/; // 非负整数
            if (regPos.test(current_page)) {
                current_page = current_page < 1 ? 1 : (current_page > total_page ? total_page : current_page);
            } else {
                current_page = 1;
            }
            data_obj.change_content(per_num, current_page);
            var inp_val = (current_page == total_page) ? 1 : current_page + 1; //跳转页数,input默认显示值
            var append_html = '<button class="prev_page">上一页</button>';
            for (var i = 0; i < total_page - 1; i++) {
                if (total_page > 8 && current_page > 6 && i < current_page - 3) {
                    if (i < 2) {
                        append_html += '<button class="page_num">' + (i + 1) + '</button>';
                    } else if (i == 2) {
                        append_html += '<span class="page_dot">•••</span>';
                    }
                } else if (total_page > 8 && current_page < total_page - 3 && i > current_page + 1) {
                    if (current_page > 6 && i == current_page + 2) {
                        // append_html+='<span class="page_dot">•••</span>';
                    } else if (current_page < 7) {
                        if (i < 8) {
                            append_html += '<button class="page_num">' + (i + 1) + '</button>';
                        } else if (i == 8) {
                            // append_html+='<span class="page_dot">•••</span>';
                        }
                    }
                } else {
                    if (i == current_page - 1) {
                        append_html += '<button class="page_num current_page">' + (i + 1) + '</button>';
                    } else {
                        append_html += '<button class="page_num">' + (i + 1) + '</button>';
                    }
                }
            }
            // if(current_page==total_page){
            //     append_html+='<button class="page_num current_page">'+(i+1)+'</button>';
            // }else{
            //     append_html+='<button class="page_num">'+(i+1)+'</button>';
            // }
            // append_html+='<button class="next_page">下一页</button><span class="page_total">共 '+total_page+' 页, 到第</span><input class="input_page_num" type="text" value="'+inp_val+'"><span class="page_text">页</span><button class="to_page_num">确定</button>';
            append_html += '<button class="next_page">下一页</button>';
            $(obj_box).children('.page_ctrl').append(append_html);
            if (current_page == 1) {
                $(obj_box + ' .page_ctrl .prev_page').attr('disabled', 'disabled').addClass('btn_dis');
            } else {
                $(obj_box + ' .page_ctrl .prev_page').removeAttr('disabled').removeClass('btn_dis');
            }
            if (current_page == total_page) {
                $(obj_box + ' .page_ctrl .next_page').attr('disabled', 'disabled').addClass('btn_dis');
            } else {
                $(obj_box + ' .page_ctrl .next_page').removeAttr('disabled').removeClass('btn_dis');
            }
        };
        page_even();
        $(obj_box + ' .page_ctrl').on('click', 'button', function() {
            var that = $(this);
            if (that.hasClass('prev_page')) {
                if (current_page != 1) {
                    current_page--;
                    that.parent('.page_ctrl').empty();
                    page_even();
                }
            } else if (that.hasClass('next_page')) {
                if (current_page != total_page) {
                    current_page++;
                    that.parent('.page_ctrl').empty();
                    page_even();
                }
            } else if (that.hasClass('page_num') && !that.hasClass('current_page')) {
                current_page = parseInt(that.html());
                that.parent('.page_ctrl').empty();
                page_even();
            } else if (that.hasClass('to_page_num')) {
                current_page = parseInt(that.siblings('.input_page_num').val());
                that.parent('.page_ctrl').empty();
                page_even();
            }
        });
    },
    getTimer() {
        var date = new Date();
        var Months =
            date.getMonth() + 1 < 10 ?
            "0" + (date.getMonth() + 1) :
            date.getMonth() + 1; //月份从0开始，因此要+1
        var Dates = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        var Hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        var Minutes =
            date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        var Seconds =
            date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        var now =
            date.getFullYear() +
            "-" +
            Months +
            "-" +
            Dates +
            " " +
            Hours +
            ":" +
            Minutes +
            ":" +
            Seconds;
        return now;
    }

}

export default magic;


// WEBPACK FOOTER //
// ./static/common/magic.js